<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"

  import { buildCalendarEventCardTags } from "../../_shared/_logic/event-card-tags"
  import type { BoardEvent } from "../../../../../../../../../_logic/calendar-types"

  interface Props {
    item: BoardEvent
    employeeLabel?: string
    showEventTooltips?: boolean
    showAppointmentTagTooltip?: boolean
    allowHorizontalOverflow?: boolean
  }

  const {
    item,
    employeeLabel = "",
    showEventTooltips = true,
    showAppointmentTagTooltip = true,
    allowHorizontalOverflow = false,
  }: Props = $props()

  const eventCardTags = $derived(buildCalendarEventCardTags({ item, employeeLabel }))
</script>

{#if eventCardTags}
  <div class="event-tag-stack" class:allow-horizontal-overflow={allowHorizontalOverflow}>
    {#if eventCardTags.addressLabel}
      <div class="event-address" title={eventCardTags.addressLabel}
        >{eventCardTags.addressLabel}</div
      >
    {/if}
    <div class="event-title event-title--appointment" title={eventCardTags.title}
      >{eventCardTags.title}</div
    >
    <div class="event-tag-row event-tag-row--appointment">
      <span class="calendar-status-tag-compact">
        <StatusTag
          class="calendar-status-tag"
          size="sm"
          status={eventCardTags.appointment.status}
          subLabel={eventCardTags.appointment.subLabel ?? undefined}
          tooltipContent={showEventTooltips && showAppointmentTagTooltip
            ? eventCardTags.appointment.tooltip
            : ""}
          tooltipHtml={true}
          tooltipClassName={eventCardTags.appointment.tooltipClassName}
          disableTitle={true}
        />
      </span>
    </div>
  </div>
{/if}

<style lang="less">
  .event-tag-stack {
    display: flex;
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
    flex-direction: column;
    gap: 0.16rem;
    overflow-x: hidden;
    overflow-y: visible;
  }

  .event-tag-stack.allow-horizontal-overflow {
    width: max-content;
    min-width: 100%;
    max-width: none;
    overflow-x: visible;
  }

  .event-title {
    flex: 0 0 auto;
    font-weight: 500;
    font-size: 0.62rem;
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-title--appointment {
    color: var(--text-invers-100);
    line-height: 1.05;
  }

  .event-address {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    color: var(--text-invers-100);
    font-size: 0.7rem;
    font-weight: 800;
    line-height: 1.05;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-tag-row {
    display: flex;
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
    align-items: stretch;
    overflow-x: hidden;
    overflow-y: visible;
  }

  .event-tag-stack.allow-horizontal-overflow .event-tag-row,
  .event-tag-stack.allow-horizontal-overflow .calendar-status-tag-compact,
  .event-tag-stack.allow-horizontal-overflow .event-tag-row :global(.status-tag),
  .event-tag-stack.allow-horizontal-overflow .calendar-status-tag-compact :global(.status-tag) {
    max-width: none;
    overflow-x: visible;
  }

  .event-tag-row--appointment {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.18rem;
  }

  .calendar-status-tag-compact {
    display: inline-flex;
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
    overflow-x: hidden;
    overflow-y: visible;
  }

  .event-tag-row :global(.status-tag),
  .calendar-status-tag-compact :global(.status-tag) {
    min-width: 0;
    max-width: 100%;
    cursor: inherit !important;
  }

  .event-tag-row :global(.status-tag *),
  .calendar-status-tag-compact :global(.status-tag *) {
    cursor: inherit !important;
  }

  .calendar-status-tag-compact :global(.status-tag__icon) {
    flex: 0 0 1.25rem;
    width: 1.25rem;
    min-width: 1.25rem;
    max-width: 1.25rem;
    height: auto;
    min-height: 0;
    max-height: none;
    box-sizing: border-box;
    display: inline-flex;
    align-self: stretch;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-size: 0.5rem;
    font-weight: 900;
  }

  .calendar-status-tag-compact :global(.status-tag__label) {
    min-width: 0;
    max-width: 100%;
    padding: 0.16rem 0.24rem;
    font-size: 0.58rem;
    font-weight: 800;
    gap: 0.04rem;
  }

  .calendar-status-tag-compact :global(.status-tag__main-label),
  .calendar-status-tag-compact :global(.status-tag__sub-label) {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .calendar-status-tag-compact :global(.status-tag__icon svg) {
    width: 0.65rem;
    height: 0.65rem;
  }
</style>
